import { Component } from '@angular/core';
import { UserService } from '@lsq-frontend/angular-shared/features/user-service';
import { ignoreNullish } from '@lsq-frontend/common-ui';
import { FeatureFlagService } from '@lsq-frontend/common-ui';
import { combineLatest } from 'rxjs';
import { map, mapTo, startWith } from 'rxjs/operators';

@Component({
    selector: 'app-dashboard',
    template: `
        <ng-container *ngIf="!(canActivate$ | async)">
            <div class="justify-content-center">
                <lsq-circle-loader></lsq-circle-loader>
            </div>
        </ng-container>
        <ng-container *ngIf="canActivate$ | async">
            <router-outlet></router-outlet>
        </ng-container>
    `
})
export class AppDashboardComponent {
    constructor(
        private _userService: UserService,
        private _featureFlagService: FeatureFlagService
    ) {}

    public canActivate$ = combineLatest([
        this._featureFlagService.featureFlagsInitialized$.pipe(startWith(false)),
        this._userService.user$.pipe(ignoreNullish(), mapTo(true), startWith(false))
    ]).pipe(map(([ff, user]) => ff && user));
}
